export default "__VITE_ASSET__goblx3cg__"